'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Label-module_label__F20pb{color:#595959;cursor:auto;left:.5rem;pointer-events:none;position:absolute;top:.5rem;transform:none;transition:none;white-space:nowrap}.Label-module_transition__zXHhw{cursor:text;left:.5rem;top:.5rem;transform:translate3d(0,calc(-50% + .75rem),0);transform-origin:top left;transition:transform .2s ease}.Label-module_centered__qOjC5{left:50%;top:1.25rem;transform:translate3d(-50%,-50%,0);transform-origin:center}.Label-module_labelDisabled__FVoqb{cursor:default}";
var styles = {"label":"Label-module_label__F20pb","transition":"Label-module_transition__zXHhw","centered":"Label-module_centered__qOjC5","labelDisabled":"Label-module_labelDisabled__FVoqb"};
styleInject["default"](css_248z, '24813da3-042b-4f35-9e50-4b8a39759e20');

exports["default"] = styles;
